import React, {Component} from 'react';
import {
	Button,
	ContentSwitcher,
	Link,
	Select,
	SelectItem,
	SelectGroup,
	Slider,
	Switch,
	Tabs,
	Tab,
	TabList,
	TabPanel,
	TabPanels,
	Tile,
	Toggle,
	ToggleSmall
} from '@carbon/react';
import CCSlider from '../../components/CCSlider';
import PropertyComponent from '../../components/PropertyComponent';
import ParameterSlider from '../../components/ParameterSlider';
import ParameterToggle from '../../components/ParameterToggle';
import { IndexedParameterSelect, IndexedParameterValue } from '../../components/IndexedParameterSelect';
import LoggingToggle from '../../components/LoggingToggle';
import MidiDevicesDialogWrapper from '../../components/MidiDevicesDialogWrapper';
import NoteDivisionParameterSelect from '../../components/NoteDivisionParameterSelect';
import DevicePropertyButton from '../../components/DevicePropertyButton';
import DevicePropertySelect from '../../components/DevicePropertySelect';
import DevicePropertyToggle from '../../components/DevicePropertyToggle';
import PresetTable from '../../components/PresetTable';

import {
	FirmwareVersionField,
	ErrorCodeField,
	PSUVoltageField,
	MidiChannelSelector
} from '../../components/ConfigSettings';
import { Renew } from '@carbon/icons-react';

import * as midi from '../../js/rpl_midi.js';

midi.setProductId(0x01, 0x01, 'Particle');
midi.initialize();

class ExprDestinationSelector extends PropertyComponent {

	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	render() {
		return (
	  				<Select value={this.state.value} labelText="" defaultValue="Dest..." onChange={this.handleChange}>
					  <SelectItem value="0" text="Off"/>
					  <SelectItem value="1" text="Blend"/>
				      <SelectItem value="15" text="Pan"/>
					  <SelectItem value="13" text="Spread"/>
					  <SelectItem value="2" text="Chop"/>
					  <SelectItem value="3" text="Freeze"/>
					  <SelectItem value="4" text="Feedback"/>
					  <SelectItem value="5" text="Fdbk Tone"/>
					  <SelectItem value="6" text="Delay Time"/>
					  <SelectItem value="7" text="Delay Rnd"/>
					  <SelectItem value="8" text="Pitch"/>
					  <SelectItem value="9" text="Detune"/>
					  <SelectItem value="10" text="Pitch Rnd"/>
					  <SelectItem value="11" text="Density"/>
					  <SelectItem value="12" text="Direction"/>
					  <SelectItem value="14" text="LFO Rate"/>
	  				</Select>
		);
	}

	handleChange(event) {
		var newValue = event.target.value;
		this.setState({value: newValue});
		midi.setIndexedParameterValue(this.propId, newValue);
	}

	setValue(x) {
		this.setState({value : x});
	}
}

class ExprSlider extends PropertyComponent {

	constructor(props) {
		super(props);

		this.restoreChangeTimer = null;
		this.handleChange = this.handleChange.bind(this);
		this.formatLabel  = this.formatLabel.bind(this);
	}

	render() {
		var onChange = this.state.suppressChange ? undefined : this.handleChange;
		return <Slider min={0} max={100} step={0.1} stepMultiplier={40} stepMuliplier={40} labelText={this.labelText} formatLabel={this.formatLabel} onChange={onChange} value={this.state.value} disabled={this.state.disabled} hideTextInput="1"/>
	}

	handleChange(props) {
		var newValue = Number(props.value);
		this.setState({value: newValue});
		midi.setParameterValue(this.propId, newValue / 100);
	}

	handleControlChange(ccNum, ccValue) {
		this.setValue(ccValue / 127);
	}

	formatLabel(value, label) {
		return '';
	}

	setValue(x) {
		// Because the property ID has bit 0x2000 set, rpl_midi does not
		// scale the value
		if (this.restoreChangeTimer) {
			clearTimeout(this.restoreChangeTimer);
		}
		this.setState({value : 100 * x / 8388608.0, suppressChange: true});
		this.restoreChangeTimer = setTimeout(() => {
			this.restoreChangeTimer = null;
			this.setState({suppressChange: false});
		}, 50);
	}
}

class ExprDestination extends React.Component {
	constructor(props) {
		super(props);

		this.destPropId = props.destPropId;
		this.minPropId  = props.minPropId;
		this.maxPropId  = props.maxPropId;
	}

	render() {
		return (
	  			<div className="cds--row editor-page__tab-ctrl">
	  			  <div className="cds--col-sm-4 cds--col-md-5 cds--col-lg-4">
	  				<ExprDestinationSelector propId={this.destPropId}/>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ExprSlider labelText="" propId={this.minPropId}/>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ExprSlider labelText="" propId={this.maxPropId}/>
	  			  </div>
	  			</div>
		);
	}
}

class ExprDestinations extends React.Component {

	createDestinations() {
		var children = [];

		for (var i = 0; i < 6; i++) {
			children.push(<ExprDestination
							destPropId={midi.PROPERTY_EXPR_DEST_1 + 3*i}
							minPropId={midi.PROPERTY_EXPR_MIN_1 + 3*i}
							maxPropId={midi.PROPERTY_EXPR_MAX_1 + 3*i}
						  />
						);
		}

		return children;
	}

	render() {
		return (
			<div>
	  			<div className="cds--row editor-page__tab-ctrl">
	  			  <div className="cds--col-sm-4 cds--col-md-5 cds--col-lg-4">
	  				Destination
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				Heel (Min)
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				Toe (Max)
	  			  </div>
	  			</div>
				{this.createDestinations()}
			</div>
		);
	}
}

class RemoteModeSelector extends PropertyComponent {
	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	createButtonAssignments() {
		if (this.state.value === 0) {
			return (
	  			<div className="cds--row editor-page__tab-ctrl">
	  			  <div className="cds--col-sm-1 cds--col-md-2 cds--col-lg-4">Preset 1</div>
	  			  <div className="cds--col-sm-1 cds--col-md-2 cds--col-lg-4">Preset 2</div>
	  			  <div className="cds--col-sm-1 cds--col-md-2 cds--col-lg-4">Preset 3</div>
	  			  <div className="cds--col-sm-1 cds--col-md-2 cds--col-lg-4">Preset 4</div>
	  			</div>
			);
		} else if (this.state.value === 1) {
			return (
	  			<div className="cds--row editor-page__tab-ctrl">
	  			  <div className="cds--col-sm-1 cds--col-md-2 cds--col-lg-4">TAP</div>
	  			  <div className="cds--col-sm-1 cds--col-md-2 cds--col-lg-4">ON</div>
	  			  <div className="cds--col-sm-1 cds--col-md-2 cds--col-lg-4">Preset +</div>
	  			  <div className="cds--col-sm-1 cds--col-md-2 cds--col-lg-4">Preset -</div>
	  			</div>
			);
		}
	}

	render() {
		return (
			<div>
	  			<div className="cds--row editor-page__tab-ctrl">
	  			  <Select labelText="Remote Mode" value={this.state.value} onChange={this.handleChange}>
	  				<SelectItem text="Mode 1 - Presets 1-4" value="0"/>
	  				<SelectItem text="Mode 2 - Stomp & Presets" value="1"/>
	  			  </Select>
	  			</div>
	  			<div className="cds--row editor-page__tab-ctrl">
	  			  <div className="cds--col-sm-1 cds--col-md-2 cds--col-lg-4">A</div>
	  			  <div className="cds--col-sm-1 cds--col-md-2 cds--col-lg-4">B</div>
	  			  <div className="cds--col-sm-1 cds--col-md-2 cds--col-lg-4">C</div>
	  			  <div className="cds--col-sm-1 cds--col-md-2 cds--col-lg-4">D</div>
	  			</div>
				{this.createButtonAssignments()}
			</div>
		);
	}

	handleChange(event) {
		var newValue = event.target.value;
		this.setState({value: newValue});
		midi.setDeviceProperty(this.propId, [newValue]);
	}

	setValue(x) {
		this.setState({value : x });
	}
}

const props = {
  exprSlider: {
	  hideTextInput: 1,
	  min: 0,
	  max: 100,
	  step: 0.1,
	  stepMultiplier: 40,
	  labelText: null,
  },
  tabs: {
    selected: 0,
    triggerHref: '#',
    role: 'navigation',
  },
  tab: {
    href: '#',
    role: 'presentation',
    tabIndex: 0,
  },
};

const EditorPage = () => {
  return (
    <div className="cds--grid cds--grid--full-width landing-page">
      <div className="cds--row editor-page__status">
        <div className="cds--col-sm-2 cds--col-md-4 cds--col-lg-8">
	    </div>
        <div className="cds--col-sm-2 cds--col-md-2 cds--col-lg-4">
	  		Status:&nbsp;
	  	    <span id="device-status"></span>
	    </div>
        <div className="cds--col-sm-1 cds--col-md-2 cds--col-lg-4">
	      <Button
	        className="editor-page__statusbtn"
	        disabled={false}
	        hasIconOnly={false}
	        iconDescription="Refresh"
	        kind="primary"
	        onClick={function noRefCheck(){midi.findMIDIDevice()}}
	        onFocus={function noRefCheck(){}}
	        renderIcon={Renew}
	        size="default"
	        tabIndex={0}
	        tooltipAlignment="center"
	        tooltipPosition="bottom"
	        type="button"
	      >Refresh</Button>
	    </div>
      </div>
      <div className="cds--row landing-page__r2">
	    <div className="cds--col cds--no-gutter">
	      <Tabs {...props.tabs}>
	        <TabList aria-label="Particle Editor tabs" className="editor-page__tabs">
	          <Tab {...props.tab}>Edit</Tab>
	          <Tab {...props.tab}>Ctrl Port</Tab>
	          <Tab {...props.tab}>Preset</Tab>
	          <Tab {...props.tab}>Config</Tab>
	          <Tab {...props.tab}>Help</Tab>
	        </TabList>
	        <TabPanels>
	        <TabPanel>
	  		  <div className="cds--grid cds--grid--no-gutter cds--grid--full-width">
	  			<div className="cds--row editor-page__tab-edit">
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ParameterSlider labelText="Blend" propId={0} ccNum={12}/>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ParameterSlider labelText="Chop/Freeze" propId={35} ccNum={103}/>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ParameterSlider labelText="Delay/Pitch" propId={36} ccNum={104}/>
	  			  </div>
	  			</div>

	  			<div className="cds--row editor-page__tab-edit">
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ParameterSlider labelText="Feedback" propId={3} ccNum={15}/>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<IndexedParameterSelect labelText="Mode" propId={8226} ccNum={102}>
					  <IndexedParameterValue value="0" text="Pitch+Dens"/>
					  <IndexedParameterValue value="1" text="Pitch+LFO"/>
					  <IndexedParameterValue value="2" text="Pitch+Detune"/>
					  <IndexedParameterValue value="3" text="Delay+Rnd"/>
					  <IndexedParameterValue value="4" text="Delay+Pitch"/>
					  <IndexedParameterValue value="5" text="Delay+Rev"/>
					  <IndexedParameterValue value="6" text="Delay+LFO"/>
					  <IndexedParameterValue value="7" text="Delay+Dens"/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ParameterSlider labelText="Param" propId={37} ccNum={105}/>
	  			  </div>
	  			</div>

	  			<div className="cds--row editor-page__tab-edit">
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ParameterSlider labelText="Fdbk Tone" propId={4} ccNum={27}/>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ParameterToggle labelText="Expert Mode" propId={33}/>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  			  </div>
	  			</div>

	  			<div className="cds--row editor-page__tab-edit">
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ParameterSlider labelText="Pan (v2.2+)" propId={20}/>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ParameterSlider labelText="Spread (v2.2+)" propId={26} ccNum={33}/>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  			  </div>
	  			</div>

	  			<div className="cds--row editor-page__tab-edit">
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ParameterSlider labelText="Density" propId={10}/>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ParameterSlider labelText="Chop" propId={1}/>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ParameterSlider labelText="Freeze" propId={2}/>
	  			  </div>
	  			</div>

	  			<div className="cds--row editor-page__tab-edit">
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ParameterSlider labelText="Delay Time" propId={5}/>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ParameterSlider labelText="Delay Rnd" propId={6}/>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ParameterSlider labelText="Direction" propId={11}/>
	  			  </div>
	  			</div>

	  			<div className="cds--row editor-page__tab-edit">
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ParameterSlider labelText="Pitch" propId={7}/>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ParameterSlider labelText="Detune" propId={8}/>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ParameterSlider labelText="Pitch Rnd" propId={9}/>
	  			  </div>
	  			</div>

	  			<div className="cds--row editor-page__tab-edit">
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				<ParameterSlider labelText="LFO Rate" propId={13}/>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  				{/*<ParameterSlider labelText="LFO Wave" propId={99}/>*/}
	  			  </div>
	  			</div>

	  			<div className="cds--row editor-page__tab-edit">
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-4">
	  				<IndexedParameterSelect labelText="Fdbk Mode (v2.2+)"
	  						defaultText="Auto"
	  						propId={8238}
	  				>
	  				  <IndexedParameterValue text="Auto" value="10"/>
	  				  <IndexedParameterValue text="Post Delay" value="2"/>
	  				  <IndexedParameterValue text="Post Delay Ping Pong" value="3"/>
	  				  <IndexedParameterValue text="Recycle" value="0"/>
	  				  <IndexedParameterValue text="Recycle Ping Pong" value="1"/>
	  				  <IndexedParameterValue text="Repeat #" value="4"/>
	  				  <IndexedParameterValue text="Repeat # / 50%" value="5"/>
	  				  <IndexedParameterValue text="Repeat # / 37%" value="6"/>
	  				  <IndexedParameterValue text="Repeat # / 25%" value="7"/>
	  				  <IndexedParameterValue text="Repeat # / 12%" value="8"/>
	  				  <IndexedParameterValue text="Repeat %" value="9"/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-4">
	  				<IndexedParameterSelect labelText="Freeze Mode" propId={8224}>
	  				  <IndexedParameterValue text="Grain" value="0"/>
	  				  <IndexedParameterValue text="Delay" value="1"/>
	  			 	</IndexedParameterSelect>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-4">
	  				<IndexedParameterSelect labelText="Pitch Qnt (v2.2+)"
	  						defaultText="Free"
	  						propId={8242}
	  				>
	  				  <IndexedParameterValue text="Free" value="0"/>
	  				  <IndexedParameterValue text="Semitones" value="1"/>
	  				  <IndexedParameterValue text="Octave Up" value="2"/>
	  				  <IndexedParameterValue text="Octave Down" value="3"/>
	  				  <IndexedParameterValue text="5th & Octave" value="4"/>
	  				  <IndexedParameterValue text="Intervals" value="5"/>
	  				  <IndexedParameterValue text="Intervals & Inversions" value="6"/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-4">
	  				<ParameterToggle labelText="Trails" labelA="Off" labelB="Trails" propId={45}/>
	  			  </div>
	  			</div>

	  			<div className="cds--row editor-page__tab-edit">
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-4">
	  				<NoteDivisionParameterSelect range="fast" labelText="Delay Div" propId={8233}/>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-4">
	  				<NoteDivisionParameterSelect range="fast" labelText="Chop Div" propId={8234}/>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-4">
	  				<NoteDivisionParameterSelect range="fast" labelText="Density Div" propId={8235}/>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-4">
	  				<NoteDivisionParameterSelect range="slow" labelText="LFO Div" propId={8236}/>
	  			  </div>
	  			</div>

	  			<div className="cds--row editor-page__tab-edit">
	  			</div>
			  </div>
	        </TabPanel>
	        <TabPanel>
	  		  <div className="cds--grid cds--grid--no-gutter cds--grid--full-width">
	  			<div className="cds--row editor-page__tab-ctrl">
	  			Expression destinations are saved to presets.  Click Save button at bottom of page to save global configuration.
	  			</div>
	  			<div className="cds--row editor-page__tab-ctrl">
	  			  <div className="cds--col-sm-2 cds--col-md-4 cds--col-lg-8">
	  				<DevicePropertySelect labelText="CTRL Port Mode" propId={midi.PROPERTY_CTRL_MODE}>
	  				  <SelectItem text="Off" value="0"/>
	  				  <SelectItem text="Expression" value="1"/>
	  				  <SelectItem text="Tap Tempo (v2.1+)" value="2"/>
	  				  <SelectItem text="Remote" value="3"/>
	  				  <SelectItem text="MIDI In (TRS) (v2.1+)" value="4"/>
	  				</DevicePropertySelect>

	  			  </div>
	  			  <div className="cds--col-sm-2 cds--col-md-4 cds--col-lg-8">
	  			    <CCSlider labelText="Expression Pedal Position" ccNum={4}/>
	  			  </div>
	  			</div>
	  			<div className="cds--row editor-page__tab-ctrl">
	  			  <h1>Expression</h1>
	  			</div>
	  			<ExprDestinations/>
	  			<div className="cds--row editor-page__tab-ctrl">
	  			  <h1>Remote</h1>
	  			</div>
	  			<RemoteModeSelector propId={midi.PROPERTY_REMOTE_BANK}/>
	  			<div className="cds--row editor-page__tab-ctrl">
	  			  <div class="cds--btn-set">
	  				<DevicePropertyButton kind="secondary" propId={midi.PROPERTY_CTRL_SAVE_CONFIG} dataBytes={[0]} refreshProps={true}>
	  				  Revert
	  				</DevicePropertyButton>
	  				<DevicePropertyButton kind="primary" propId={midi.PROPERTY_CTRL_SAVE_CONFIG} dataBytes={[1]}>
	  				  Save
	  				</DevicePropertyButton>
	  			  </div>
	  			</div>
	  		  </div>
	        </TabPanel>
	        <TabPanel>
	  		  <PresetTable numProgs={127} liveProg={128} allowRename={true}/>
	  		  <div className="cds--row editor-page__tab-ctrl">
	  		  <p>&nbsp;&nbsp;&nbsp;&nbsp;Preset rename, copy, paste, and transfer to/from pedal require firmware version 2.2 or later.</p>
	  		  </div>
	        </TabPanel>
	        <TabPanel>
	  		  <div className="cds--grid cds--grid--no-gutter cds--grid--full-width">
	  			<div className="cds--row editor-page__tab-config">
	  			<FirmwareVersionField propId={midi.PROPERTY_FIRMWARE_VERSION}/>
	  			</div>
	  			<div className="cds--row editor-page__tab-config">
	  			<PSUVoltageField propId={midi.PROPERTY_PSU_VOLTAGE}/>
	  			</div>
	  			<div className="cds--row editor-page__tab-config">
	  			<ErrorCodeField propId={midi.PROPERTY_ERROR_CODE}/>
	  			</div>
	  			<div className="cds--row editor-page__tab-config">
	  			  <DevicePropertySelect labelText="Left Footswitch (v2.2.4+)" propId={midi.PROPERTY_AUX_SWITCH_MODE}>
	  			    <SelectItem text="Tap/[Freeze]" value="0"/>
					<SelectItem text="Tap" value="1"/>
					<SelectItem text="Freeze (Momentary)" value="2"/>
					<SelectItem text="Freeze (Latch)" value="3"/>
	  			    <SelectItem text="Preset" value="4"/>
	  			    <SelectItem text="Preset Shift" value="5"/>
	  			  </DevicePropertySelect>
	  			</div>
	  			<div className="cds--row editor-page__tab-config">
	  			  <DevicePropertySelect labelText="Max. Input Level" propId={midi.PROPERTY_MAX_INPUT_LEVEL}>
	  			    <SelectItem text="+7 dBu" value="1"/>
	  			    <SelectItem text="+5 dBu" value="2"/>
	  			    <SelectItem text="+0.5 dBu" value="3"/>
	  			  </DevicePropertySelect>
	  			</div>
	  			<div className="cds--row editor-page__tab-config">
	  			  <DevicePropertySelect labelText="Input/Output Configuration (v2.2+)" propId={midi.PROPERTY_IO_CONFIG}>
	  			    <SelectItem text="Auto Detect (beta)" value="3"/>
	  			    <SelectItem text="Mono In / Mono Out" value="1"/>
	  			    <SelectItem text="Mono In / Stereo Out" value="2"/>
	  			    <SelectItem text="Stereo In / Stereo Out" value="0"/>
	  			  </DevicePropertySelect>
	  			</div>
	  			<div className="cds--row editor-page__tab-config">
	  			  <DevicePropertySelect labelText="Bypass Mode" propId={midi.PROPERTY_BYPASS_MODE}>
	  			    <SelectItem text="DSP" value="2"/>
	  			    <SelectItem text="Analog" value="1"/>
	  				<SelectItem text="Analog + FX Level (v2.2+)" value="4"/>
	  			    <SelectItem text="Kill Dry" value="3"/>
	  			  </DevicePropertySelect>
	  			</div>
	  			<div className="cds--row editor-page__tab-config">
	  			  <MidiChannelSelector propId={midi.PROPERTY_MIDI_CHANNEL}/>
	  			</div>
	  			<div className="cds--row editor-page__tab-config">
	  				<DevicePropertyToggle labelText="Receive MIDI Clock (v2.1+)" labelA="Off" labelB="On" propId={midi.PROPERTY_RECEIVE_MIDI_CLOCK}/>
	  			</div>
	  		  </div>
	        </TabPanel>
	        <TabPanel>
			  <h3>Resources</h3>
  				<Link href="https://redpandalab.freshdesk.com/support/home">Knowledge Base</Link><br/>
				<Link href="http://www.redpandalab.com/downloads/">User Manuals and Firmware Updates</Link><br/>
				<Link href="http://www.redpandalab.com/contact/">Contact Us</Link><br/>

	  		  <h3>Expression Pedal</h3>
  				<p>To assign the expression pedal to any combination of knobs:
  				<ol>
  				  <li>1. Hold the right footswitch while pluggin in the expression pedal (right LED will blink orange 3x).</li>
  				  <li>2. Move expression pedal to the heel down position.</li>
  				  <li>3. Adjust knobs for the desired sound.</li>
  				  <li>4. Move expression pedal to the toe down position.</li>
  				  <li>5. Adjust knobs for the desired sound.</li>
  				  <li>6. Hold the right footswitch for 2 seconds to save (right LED will blink green).</li>
  				</ol>
  				</p>
	
  			  <h3>Limitations</h3>
				<ul>
  	  		  	  <li>The web editor does not reflect changes made by another MIDI device.
  	  			      Hit Refresh to update.</li>
				</ul>

 			  <h3>Troubleshooting</h3>
	  		  <div className="cds--row editor-page__tab-help">
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  		        <MidiDevicesDialogWrapper/>
	  			  </div>
	  			  <div className="cds--col-sm-4 cds--col-md-4 cds--col-lg-5">
	  		        <LoggingToggle/>
	  			  </div>
	  		  </div>
	        </TabPanel>
	        </TabPanels>
	      </Tabs>
	    </div>
      </div>
      <div className="cds--row landing-page__r3">
      </div>
    </div>
  );
};

export default EditorPage;
